import React from 'react';
import { EMP_DETAILS_TYPE } from '../../../utils/Constant';
import { EMPLOYEE_DATA_HEADER } from '../AdminSettingsHelper';
import EmployeeDetails from './EmployeeDetails';

const EmployeeDataPage: React.FunctionComponent = () => {
  return (
    <EmployeeDetails
      detailType={EMP_DETAILS_TYPE.DATA}
      columnsHeder={EMPLOYEE_DATA_HEADER}
      title="Employee Data"
    />
  );
};
export default EmployeeDataPage;
